import { motion } from "framer-motion";
import { MapPin, Phone, Clock, MessageCircle, Mail } from "lucide-react";

export default function Contact({ content }) {
  const items = [
    { icon: MapPin, label: "Dirección", value: content.address },
    { icon: Phone, label: "Teléfono", value: content.phone, href: `tel:${content.phone.replace(/[^+\d]/g, "")}` },
    { icon: Clock, label: "Horario", value: content.hours },
    { icon: Mail, label: "Correo", value: content.email, href: `mailto:${content.email}` },
  ];

  return (
    <section id="contacto" className="relative py-24 md:py-36 bg-[#f9f6f0]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-[#da251d] uppercase tracking-[0.3em] text-xs font-semibold mb-4">Visítanos</p>
            <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tight leading-none mb-10">
              Te esperamos en Upland
            </h2>

            <div className="space-y-6">
              {items.map((it, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.08 }}
                  className="flex items-start gap-4"
                >
                  <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#da251d]/10 text-[#da251d]">
                    <it.icon size={20} />
                  </span>
                  <div>
                    <p className="text-xs uppercase tracking-widest text-stone-400 font-semibold">{it.label}</p>
                    {it.href ? (
                      <a href={it.href} className="text-lg font-medium hover:text-[#da251d] transition-colors">{it.value}</a>
                    ) : (
                      <p className="text-lg font-medium">{it.value}</p>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href={content.doordash_url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-order-btn"
                className="inline-flex items-center justify-center rounded-full bg-[#da251d] text-white font-semibold px-8 py-4 transition-transform duration-200 hover:bg-[#b91c1c] active:scale-95"
              >
                Ordenar en DoorDash
              </a>
              {content.whatsapp && (
                <a
                  href={`https://wa.me/${content.whatsapp.replace(/[^\d]/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-whatsapp-btn"
                  className="inline-flex items-center justify-center gap-2 rounded-full border border-stone-300 font-semibold px-8 py-4 transition-colors duration-200 hover:border-[#da251d] hover:text-[#da251d]"
                >
                  <MessageCircle size={18} /> WhatsApp
                </a>
              )}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative h-[380px] md:h-[520px] overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.12)]"
          >
            <iframe
              title="Mapa Inca's Peruvian Grill"
              src={content.map_embed}
              className="h-full w-full border-0 grayscale-[0.2]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
